export default [

     {
          path: '/business-continuity-plan',
          name: 'BusinessContinuityPlan',
          component: () => import("@/views/Page/BusinessContinuityPlan/BusinessContinuityPlan.vue"),
          meta: {
               title: 'Business Continuity Plan',
          },
     },
     {
          path: '/business-continuity-plan-details/:id',
          name: 'BusinessContinuityPlanDetails',
          component: () => import("@/views/Page/BusinessContinuityPlan/BusinessContinuityPlanDetails.vue"),
          meta: {
               title: 'Business Continuity Plan Details',
               permission: "BusinessContinuityPlanStep.show"
          },
     }
];